// adminApi.js
import axios from "axios";

const COUNTRYPRICE_API_SERVICE = `${process.env.REACT_APP_API_URL}/adminservice/api/country-pricing`;

const apiClient = axios.create({
  baseURL: COUNTRYPRICE_API_SERVICE,
  withCredentials: true,
});

const countryPriceApi = {
  saveCreditPricing: (payload) => apiClient.post("/add", payload),

  getCompanyPricing: (page, size, sortedColumn, sortedOrder) =>
    apiClient.get("/allCountryPrices", {
      params: {
        page,
        size,
        sortedColumn,
        sortedOrder,
      },
    }),

  getCountryPriceByCode: (countryCode) =>
    apiClient.get("/getCountryPriceByCode", {
      params: {
        countryCode,
      },
    }),
  getCountryPriceByCodeAndRole: (countryCode, role) =>
    apiClient.get(`/getVisbileRoles/${countryCode}/${role}`),

  updateCountryPrice : (id , payload) => apiClient.put(`/update/${id}`, payload),

  getCountOfActiveCountries : () => apiClient.get("/count"),
};

export default countryPriceApi;
